import {
  buildTourStorageKey,
  requestProductTourRestart,
} from '@terra/ui-product-tour';
import {
  BOOTH_VAULT_TOUR_ID,
  boothVaultTourDefinition,
} from '../../product-tours/booth-vault.tour';

export const requestBoothTourRestart = (): void => {
  requestProductTourRestart({
    tourId: BOOTH_VAULT_TOUR_ID,
    storageKey: buildTourStorageKey(boothVaultTourDefinition),
  });
};
